import { $http } from "@/assets/js/appFunc";
import i18n from "@/i18n/index";

/**
 * get users
 * "GET" - get all users
 * "POST" - get users using pageNumber and pageSize
 */
export const getUsersList = (context, payload) => {
    let req = {};
    if (payload && payload.fromProcessInspector) {
        const addSearchValue = payload.searchValue ? `?searchInput=${encodeURIComponent(payload.searchValue)}` : "";
        const pagination = payload.pagination ? `&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}` : "";
        let addQueryParam = addSearchValue + pagination;
        if (addQueryParam) {
            addQueryParam = `?${addQueryParam.substr(1)}`;
        }
        req = {
            type: "GET",
            url: `/identity/tenants/process-inspector/users${addQueryParam}`
        };
    } else {
        req = {
            type: payload ? "POST" : "GET",
            url: "/identity/tenants/users",
            data: payload
        };
    }
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                // data.data = data.data.filter(user => (user.email && user.username));
                if (!payload) {
                    context.commit("setUserList", data);
                }
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const createNewUser = (context, newUser) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/users/admin-ui",
        data: newUser
    };
    $http(req, true).then(
        data => {
            newUser.id = data.data.id;
            newUser.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
            context.commit("setUserList", { addNewUser: true, data: newUser });
        },
        error => console.log(error)
    );
};

export const actCreateUpdateUser = (context, user) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/users/admin-ui/saveUserWithRoles",
        data: user,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                user.id = data.data.id;
                user.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
                user.avatarPath = data && data.data && data.data.avatarPath ? data.data.avatarPath : null;
                context.commit("setUserList", { addNewUser: user.addNewUser, data: user });
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const saveEditUser = (context, dataToSave) => {
    const req = {
        type: "POST",
        url: "/identity/tenants/users/admin-ui",
        data: dataToSave
    };
    $http(req, true).then(
        data => {
            dataToSave.disabledDatetime = data && data.data && data.data.disabledDatetime ? data.data.disabledDatetime : null;
            context.commit("setUserList", { data: dataToSave });
        },
        error => console.log(error)
    );
};

export const addUsersToRole = (context, payload) => {
    // let payload = list.map(users => users.id);

    const req = {
        type: "POST",
        url: "/identity/tenants/user-group",
        data: payload.dataUsers
    };
    $http(req, true).then(
        () => {
            context.commit("setUserRoleList", { response: payload.dataUsers, roleId: payload.roleId });
        },
        error => console.log(error)
    );
};

export const getUsersForRole = (context, respData) => {
    if (respData.rolesList.userDtos) {
        context.commit("setCurrentUsersForRole", respData.rolesList);
    } else {
        const req = {
            type: "GET",
            url: `/identity/tenants/group/admin-ui/${respData.roleId}`
        };
        $http(req, true).then(
            data => {
                context.commit("setUserRoleList", { response: data.data.userDtos || [] });
                context.commit("setCurrentUsersForRole", data.data.userDtos || []);
            },
            error => console.log(error)
        );
    }
};

export const getPermissionsForUser = (context, respData) => {
    if (respData.permissionsList.groupPermissionDtos) {
        context.commit("setCurrentPermissionsForUser", respData.permissionsList);
    } else if (respData.userId) {
        const req = {
            type: "GET",
            url: `/identity/tenants/users/admin-ui/${respData.userId}`
        };
        $http(req, true).then(
            data => {
                const directPermTranslation = {};
                const changeIds = (dataPermissions) => {
                    const newData = [];
                    if (dataPermissions) {
                        dataPermissions.forEach(appData => {
                            const newIds = [];
                            const { targetId, id } = appData;
                            const appId = targetId || id;
                            if (!directPermTranslation[appId]) {
                                directPermTranslation[appId] = {};
                            }
                            appData.roles.forEach(elem => {
                                if (elem.code === "INITIATOR" && elem.id) {
                                    newIds.push(elem);
                                    directPermTranslation[appId][elem.id] = `${i18n.t("applicationPermissions.INITIATORTitle")} "${elem.name}"`;
                                } else {
                                    newIds.push(elem);
                                    directPermTranslation[appId][elem.code] = elem.name;
                                }
                            });
                            newData.push({ ...appData, roles: newIds });
                        });
                    }
                    return newData.length ? newData : dataPermissions;
                };
                const changeData = (v) => {
                    const processDetailsAndRoles = changeIds(v.processDetailsAndRoles);
                    const inheritedRoles = changeIds(v.inheritedRoles);
                    return { ...v, processDetailsAndRoles, inheritedRoles };
                };
                const dataFormated = changeData(data.data);
                context.commit("setRolesUserList", { response: dataFormated.groups || [] });
                context.commit("setCurrentRolesForUser", dataFormated.groups || []);

                context.commit("setPermissionsUserList", { response: dataFormated.permissions || [] });
                context.commit("setCurrentPermissionsForUser", dataFormated.permissions || []);
                context.commit("setProcessDetailsAndRoles", {
                    directPermTranslation,
                    directPermissions: dataFormated.processDetailsAndRoles,
                    inheritedPermissions: dataFormated.inheritedRoles
                }); // PERMISSISONS:new Permissions System);
            },
            error => console.log(error)
        );
    }
};

export const deleteUserFromRole = (context, data) => {
    const req = {
        type: "DELETE",
        url: `/identity/tenants/user-groups/${data.role.id}/${data.user.id || data.user.userId}`,
        data: null
    };
    $http(req, true).then(
        () => context.commit("deleteUser", data.user),
        error => console.log(error)
    );
};

// bulk invite users actions
export const parseUsersFile = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/invite/principal/parse-file",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const createNewInvitedUser = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/invite/principal/create-and-notify-users",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const setupNewUser = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/invite/without-principal/setup-user",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getInvitedUserInfo = (context, userId) => {
    const req = {
        type: "GET",
        url: `/identity/invite/without-principal/user-information/${userId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getUserWallet = (context, userId) => {
    const req = {
        type: "GET",
        url: `/identity/tenants/users/awaits/wallet-password/setting?userEmail=${userId}`
    };
    return $http(req, true);
};

export const saveWalletPassword = (context, payload) => {
    const req = {
        type: "PUT",
        url: `/blockchain/wallets/${payload.walletId}/users/${payload.userId}/vault`,
        data: payload.encrypted,
        headers: { "Content-Type": "application/json" }
    };

    return $http(req, true);
};

export const getWalletInfo = (context, userId) => {
    const req = {
        type: "GET",
        url: `/identity/tenants/users/${userId}/wallet`
    };

    return $http(req, true);
};

export const SSOButtonAction = (context, { type, configId }) => {
    const req = {
        type: "GET",
        url: `/identity/auth/sso/${type}/config/${configId}/login`
    };

    return $http(req, true);
};

export const getSSOButtons = () => {
    const req = {
        type: "GET",
        url: "/identity/public/sso/buttons"
    };

    return $http(req, true);
};
